export function useClearConsigneeContact(modelValue) {

    modelValue.consigneeContactId = 0;
    modelValue.consigneeContactFullName = '';
    modelValue.consigneeContactTitle = '';
    modelValue.consigneeContactFirstName = '';
    modelValue.consigneeContactLastName = '';
    modelValue.consigneeContactPhone = '';
    modelValue.consigneeContactEmail = '';

}
